import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  FormCheckbox,
  Col,
  Form,
  FormGroup,
  FormInput,
} from "shards-react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContainer, toast } from "react-toastify";
import {
  faFileLines,
  faCircleXmark,
} from "@fortawesome/free-regular-svg-icons";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import { SelectAgency, SelectIndicatorsPermission } from "shared/components";

const axios = require("axios").default;
const ModalClose = styled.a`
  color: black;
  cursor: pointer;
  position: absolute;
  right: 20px;
  :hover {
    color: black;
  }
`;

const StyledModalFooter = styled(ModalFooter)`
  display: block;
`;

const ModalAddPermission = (props) => {
  const { token } = useToken();
  const { open, toggle, userId, selectData } = props;
  const [agencyId, setAgencyId] = useState(null);
  const [indicatorsDatasetId, setIndicatorsDatasetId] = useState(null);

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };
  const onSavePermission = () => {
    const sendObject = {
      params: {
        userId: userId,
      },
      update: {
        permission: [
          {
            userId: userId,
            indicatorsDatasetSettingId: indicatorsDatasetId,
          },
        ],
      },
    };
    
    var config = {
      method: "post",
      url: `${baseUrl}/v1/user/update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: sendObject,
    };

    axios(config)
      .then((response) => {
        showNotify("แจ้งเตือน! บันทึกข้อมูลเรียบร้อย");
        toggle();
      })
      .catch((error) => {
        console.log(error);
        if(error.response.data.message){
          showNotify(error.response.data.message, "error");
        }else{
          showNotify(error.message, "error");
        }
      });
  };
  return (
    <>
      <Modal size="lg" open={open} toggle={toggle}>
        <ModalHeader tag="h6" titleClass="bold" style={{ border: "none" }}>
          เพิ่มสิทธิการเข้าถึงข้อมูล/ตัวชี้วัด
          <ModalClose onClick={toggle}>
            <FontAwesomeIcon icon={faCircleXmark} />
          </ModalClose>
        </ModalHeader>
        <ModalBody>
          <Form className="my-form">
            <FormGroup className="mt-2">
              <label>เลือกหน่อยงานของตัวชี้วัด</label>
              <SelectAgency
                placeholder="เลือก"
                name="indicatorsDatasetId"
                onChange={(e) => {
                  setAgencyId(
                    e.target.value === "0" ? null : e.target.value
                  );
                }}
                defaultValue={agencyId}
                value={agencyId}
              />
            </FormGroup>
            <FormGroup className="mt-2">
              <label>เลือกตัวชี้วัด</label>
              <SelectIndicatorsPermission
                placeholder="เลือก"
                name="indicatorsDatasetId"
                onChange={(e) => {
                  setIndicatorsDatasetId(
                    e.target.value === "0" ? null : e.target.value
                  );
                }}
                defaultValue={indicatorsDatasetId}
                value={indicatorsDatasetId}
                selectList={selectData}
                agencyId={agencyId}
                disabled={agencyId == 0 || agencyId == null}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <StyledModalFooter>
          <Button
            className="btn-success pull-right"
            onClick={onSavePermission}
            style={{ width: "150px" }}
          >
            เลือก
          </Button>
          <Button className="btn-white  pull-right" onClick={toggle}>
            ยกเลิก
          </Button>
        </StyledModalFooter>
      </Modal>
    </>
  );
};

export default ModalAddPermission;
